// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comments-page {
  font-family: Arial, sans-serif;
  background: #f8f9fa;
  min-height: 100vh;
}

.comments-page__topbar-actions {
  display: flex;
  align-items: center;
  color: white;
}

.comments-page__content {
  max-width: 980px;
  margin: 0 auto;
  padding: 24px;
}

.comments-page__header {
  margin-bottom: 20px;
}

.comments-page__title {
  margin: 0;
  color: #1a1a1a;
  font-size: 24px;
  font-weight: 600;
}

.comments-page__subtitle {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 14px;
}

.comments-page__subtitle span {
  color: #1f2937;
  font-weight: 600;
}

.comments-page__thread-card,
.comments-page__composer {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.comments-page__thread-card {
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.comments-page__table-meta {
  display: flex;
  justify-content: space-between;
  margin-bottom: 14px;
  font-size: 13px;
  color: #64748b;
}

.comments-page__chat-list {
  min-height: 180px;
  max-height: clamp(220px, 40vh, 420px);
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior: contain;
  scroll-behavior: smooth;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 8px 4px 2px;
  border-top: 1px solid #f1f5f9;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(180deg, #fafcff 0%, #ffffff 100%);
}

.comments-page__chat-list {
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.comments-page__chat-list::-webkit-scrollbar {
  width: 10px;
}

.comments-page__chat-list::-webkit-scrollbar-track {
  background: transparent;
}

.comments-page__chat-list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 999px;
  border: 2px solid transparent;
  background-clip: padding-box;
}

.comments-page__chat-list::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
  background-clip: padding-box;
}

.comments-page__message {
  display: flex;
  gap: 10px;
  align-items: flex-end;
}

.comments-page__message--outgoing {
  flex-direction: row-reverse;
}

.comments-page__message-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e2e8f0;
  color: #334155;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  flex-shrink: 0;
}

.comments-page__message--outgoing .comments-page__message-avatar {
  background: #dbeafe;
  color: #1e40af;
}

.comments-page__bubble {
  max-width: min(75%, 700px);
  border-radius: 12px;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  background: #f8fafc;
}

.comments-page__message--outgoing .comments-page__bubble {
  border: 1px solid #bfdbfe;
  background: #eff6ff;
}

.comments-page__bubble-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
  font-size: 12px;
}

.comments-page__bubble-user {
  font-weight: 600;
  color: #1f2937;
}

.comments-page__bubble-source {
  color: #0369a1;
  background: #e0f2fe;
  border-radius: 999px;
  padding: 2px 8px;
  font-weight: 600;
}

.comments-page__bubble-time {
  color: #64748b;
  margin-left: auto;
}

.comments-page__bubble-text {
  margin: 0;
  color: #111827;
  font-size: 14px;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
}

.comments-page__status {
  margin: 0;
  padding: 16px;
  text-align: center;
  color: #64748b;
}

.comments-page__composer {
  margin-top: 20px;
  padding: 16px;
}

.comments-page__composer-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.comments-page__input {
  width: 100%;
  min-height: 88px;
  resize: vertical;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
  box-sizing: border-box;
}

.comments-page__input:focus {
  border-color: #0070d2;
  box-shadow: 0 0 0 3px rgba(0, 112, 210, 0.15);
}

.comments-page__composer-help {
  margin: 8px 0 0;
  color: #64748b;
  font-size: 12px;
}

.comments-page__composer-actions {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .comments-page__content {
    padding: 16px;
  }

  .comments-page__table-meta {
    flex-direction: column;
    gap: 4px;
  }

  .comments-page__bubble {
    max-width: 85%;
  }

  .comments-page__chat-list {
    max-height: 42vh;
  }

  .comments-page__bubble-meta {
    flex-wrap: wrap;
  }

  .comments-page__bubble-time {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Model/Comments.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,wBAAwB;EACxB,6BAA6B;EAC7B,gCAAgC;EAChC,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":[".comments-page {\n  font-family: Arial, sans-serif;\n  background: #f8f9fa;\n  min-height: 100vh;\n}\n\n.comments-page__topbar-actions {\n  display: flex;\n  align-items: center;\n  color: white;\n}\n\n.comments-page__content {\n  max-width: 980px;\n  margin: 0 auto;\n  padding: 24px;\n}\n\n.comments-page__header {\n  margin-bottom: 20px;\n}\n\n.comments-page__title {\n  margin: 0;\n  color: #1a1a1a;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.comments-page__subtitle {\n  margin: 8px 0 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.comments-page__subtitle span {\n  color: #1f2937;\n  font-weight: 600;\n}\n\n.comments-page__thread-card,\n.comments-page__composer {\n  background: white;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.comments-page__thread-card {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.comments-page__table-meta {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 14px;\n  font-size: 13px;\n  color: #64748b;\n}\n\n.comments-page__chat-list {\n  min-height: 180px;\n  max-height: clamp(220px, 40vh, 420px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  overscroll-behavior: contain;\n  scroll-behavior: smooth;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 4px 8px 4px 2px;\n  border-top: 1px solid #f1f5f9;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(180deg, #fafcff 0%, #ffffff 100%);\n}\n\n.comments-page__chat-list {\n  scrollbar-width: thin;\n  scrollbar-color: #cbd5e1 transparent;\n}\n\n.comments-page__chat-list::-webkit-scrollbar {\n  width: 10px;\n}\n\n.comments-page__chat-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.comments-page__chat-list::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 999px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n}\n\n.comments-page__chat-list::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n  background-clip: padding-box;\n}\n\n.comments-page__message {\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n}\n\n.comments-page__message--outgoing {\n  flex-direction: row-reverse;\n}\n\n.comments-page__message-avatar {\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #e2e8f0;\n  color: #334155;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.comments-page__message--outgoing .comments-page__message-avatar {\n  background: #dbeafe;\n  color: #1e40af;\n}\n\n.comments-page__bubble {\n  max-width: min(75%, 700px);\n  border-radius: 12px;\n  padding: 10px 12px;\n  border: 1px solid #e2e8f0;\n  background: #f8fafc;\n}\n\n.comments-page__message--outgoing .comments-page__bubble {\n  border: 1px solid #bfdbfe;\n  background: #eff6ff;\n}\n\n.comments-page__bubble-meta {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 6px;\n  font-size: 12px;\n}\n\n.comments-page__bubble-user {\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.comments-page__bubble-source {\n  color: #0369a1;\n  background: #e0f2fe;\n  border-radius: 999px;\n  padding: 2px 8px;\n  font-weight: 600;\n}\n\n.comments-page__bubble-time {\n  color: #64748b;\n  margin-left: auto;\n}\n\n.comments-page__bubble-text {\n  margin: 0;\n  color: #111827;\n  font-size: 14px;\n  line-height: 1.45;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.comments-page__status {\n  margin: 0;\n  padding: 16px;\n  text-align: center;\n  color: #64748b;\n}\n\n.comments-page__composer {\n  margin-top: 20px;\n  padding: 16px;\n}\n\n.comments-page__composer-label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n}\n\n.comments-page__input {\n  width: 100%;\n  min-height: 88px;\n  resize: vertical;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.comments-page__input:focus {\n  border-color: #0070d2;\n  box-shadow: 0 0 0 3px rgba(0, 112, 210, 0.15);\n}\n\n.comments-page__composer-help {\n  margin: 8px 0 0;\n  color: #64748b;\n  font-size: 12px;\n}\n\n.comments-page__composer-actions {\n  margin-top: 12px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: 768px) {\n  .comments-page__content {\n    padding: 16px;\n  }\n\n  .comments-page__table-meta {\n    flex-direction: column;\n    gap: 4px;\n  }\n\n  .comments-page__bubble {\n    max-width: 85%;\n  }\n\n  .comments-page__chat-list {\n    max-height: 42vh;\n  }\n\n  .comments-page__bubble-meta {\n    flex-wrap: wrap;\n  }\n\n  .comments-page__bubble-time {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
